import React from 'react';
import { Slider, Space, Card, Typography, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface LabeledSliderProps {
    title: string;
    emoji?: string;
    min: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
    labels?: string[];
    unit?: string;
    step?: number;
}

const LabeledSlider: React.FC<LabeledSliderProps> = ({
    title,
    emoji,
    min,
    max,
    value,
    onChange,
    labels,
    unit,
    step = 1
}) => {
    // État local pour l'affichage en temps réel pendant le glissement
    const [localValue, setLocalValue] = React.useState<number>(value);

    // Synchroniser avec la valeur externe quand elle change
    React.useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const isActive = localValue !== max;

    return (
        <Card size="small" style={{ marginBottom: 8 }}>
            <Space direction="vertical" style={{ width: '100%' }} size="small">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text strong style={{ fontSize: 12 }}>
                        {emoji && `${emoji} `}{title}
                    </Text>
                    {isActive && (
                        <Button
                            type="text"
                            size="small"
                            icon={<CloseOutlined />}
                            onClick={() => {
                                setLocalValue(max);
                                onChange(max);
                            }}
                            style={{ padding: 0, height: 'auto' }}
                        />
                    )}
                </div>
                <Slider
                    min={min}
                    max={max}
                    step={step}
                    value={localValue}
                    onChange={(val) => {
                        // Mise à jour locale pour l'affichage en temps réel
                        setLocalValue(val);
                    }}
                    onAfterChange={(val) => {
                        // Mise à jour réelle seulement quand on relâche
                        onChange(val);
                    }}
                    tooltip={{
                        formatter: (val) => labels ? (labels[val || 0] || '') : (val || 0).toString()
                    }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11 }}>
                    <Text type="secondary" style={{ fontSize: 11 }}>
                        Max: <Text strong style={{ color: '#1890ff' }}>
                            {labels ? (labels[localValue] || '') : localValue}
                        </Text>
                    </Text>
                </div>
            </Space>
        </Card>
    );
};

export default LabeledSlider;
